import styled from 'styled-components';

export const Image = styled.img`
  width: 100%;
`;
export const Content = styled.div`
  width: 100%;
`;
